export default class PickupService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllPickups(args) {
    return this.axiosIns.get(this.serviceConfig.pickups, { params: args });
  }

  getPickup(id, args) {
    return this.axiosIns.get(`${this.serviceConfig.pickups}/${id}`, { params: args });
  }

  cancelPickup(id, args) {
    return this.axiosIns.patch(`${this.serviceConfig.pickups}/${id}/cancel`, args);
  }

  createPickup(args) {
    return this.axiosIns.post(`${this.serviceConfig.pickups}`, args);
  }

  updatePickup(args, id) {
    return this.axiosIns.put(`${this.serviceConfig.pickups}/${id}`, args);
  }
}
